import { getStateToken, isAuthenticated, signOut, getAbbreviatedName } from './utils/functions';
import { AUTHENTICATE_API, USER_RESET_PASSWORD_POST_API } from './constants/apis'
import { LOGIN_PATH } from './constants/paths';


export const AuthProvider = {
    is_authenticated: false,
    user_id: null,
    username: '',
    permission_ids: [],
    access_level: null,
    main_path: LOGIN_PATH,
    redirect_to: null,
    getParameters() {
        return {
            is_authenticated: AuthProvider.is_authenticated,
            user_id: AuthProvider.user_id,
            username: AuthProvider.username,
            permission_ids: AuthProvider.permission_ids,
            access_level: AuthProvider.access_level,
            main_path: AuthProvider.main_path,
            redirect_to: AuthProvider.redirect_to
        };
    },
    setRedirectTo(redirect_to) {
        AuthProvider.redirect_to = redirect_to;
    },
    async authenticate(email, password) {
        let stateToken = await getStateToken(true);

        if(stateToken) {
            const headers = new Headers({
                'Content-Type': 'application/json',
                'state': stateToken
            });

            const postData = {
                email,
                password
            };

            const body = JSON.stringify(postData);

            try {
                let response = await fetch(AUTHENTICATE_API,
                    {
                        method: "POST",
                        headers: headers,
                        cache: 'no-store',
                        body: body,
                    });

                if(!response.ok) {
                    return {
                        requestFailed: true,
                        response
                    };
                }

                let data = await response.json();

                AuthProvider.is_authenticated = true;
                AuthProvider.user_id = data.user_id;
                AuthProvider.username = data.username ? getAbbreviatedName(data.username) : '';
                AuthProvider.permission_ids = data.permission_ids || [];
                AuthProvider.access_level = data.access_level || null;
                AuthProvider.main_path = data.main_path || LOGIN_PATH;
                
                return {
                    requestFailed: false,
                    data
                };
            }
            catch(error) {
                console.log(error);
            }
        }

        AuthProvider.is_authenticated = false;
        AuthProvider.user_id = null;
        AuthProvider.username = '';
        AuthProvider.permission_ids = [];
        AuthProvider.access_level = null;
        AuthProvider.main_path = LOGIN_PATH;

        return null;
    },
    async recoverPassword(password, authHash) {
        let stateToken = await getStateToken(true);

        if(stateToken) {
            const headers = new Headers({
                'Content-Type': 'application/json',
                'state': stateToken
            });

            const body = JSON.stringify({
                password
            });

            try {
                let response = await fetch(`${USER_RESET_PASSWORD_POST_API}${authHash}`,
                    {
                        method: "POST",
                        headers: headers,
                        cache: 'no-store',
                        body: body,
                    });

                if(!response.ok) {
                    return {
                        requestFailed: true,
                        response
                    };
                }

                let data = await response.json();
                
                return {
                    requestFailed: false,
                    data
                };
            }
            catch(error) {
                console.log(error);
            }
        }
    },
    async signOut() {
        await signOut();

        AuthProvider.is_authenticated = false;
        AuthProvider.user_id = null;
        AuthProvider.username = '';
        AuthProvider.permission_ids = [];
        AuthProvider.access_level = null;
        AuthProvider.main_path = LOGIN_PATH;
        AuthProvider.redirect_to = null;

        return true;
    },
    async isAuthenticated() {
        let data = await isAuthenticated();

        if (data) {
            AuthProvider.is_authenticated = data.is_authenticated;
            AuthProvider.user_id = data.user_id;
            AuthProvider.username = data.username ? getAbbreviatedName(data.username) : '';
            AuthProvider.permission_ids = data.permission_ids || [];
            AuthProvider.access_level = data.access_level || null;
            AuthProvider.main_path = data.main_path || LOGIN_PATH;
        }
        else {
            AuthProvider.is_authenticated = false;
            AuthProvider.user_id = null;
            AuthProvider.username = '';
            AuthProvider.permission_ids = [];
            AuthProvider.access_level = null;
            AuthProvider.main_path = LOGIN_PATH;
        }

        return data;
    },
  };